import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { ProgramFunctionContactService, FunctionContactService } from '../../camtl.service';
import { Contact } from '../../../../shared/model';
import { SystemSelectService } from '../../system-select/system-select.service';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';
import { CgpGridComponent } from '../../../../shared/cgp-grid/cgp-grid.component';
import { CgpSnackbarService } from '../../../../shared/cgp-snackbar/cgp-snackbar.service';
import { CgpConfirmationDialogService } from '../../../../shared/cgp-confirmation-dialog/cgp-confirmation-dialog.service';
import { CgpAlertDialogService } from '../../../../shared/cgp-alert-dialog/cgp-alert-dialog.service';

@Component({
  selector: 'app-camtl-program-contacts',
  templateUrl: './camtl-program-contacts.component.html',
  // styleUrls: ['./camtl-program-contacts.component.scss']
})
export class CamtlProgramContactsComponent implements OnInit {

  constructor(
    private systemSelectService: SystemSelectService,
    private programFunctionContactService: ProgramFunctionContactService,
    private functionContactService: FunctionContactService,
    private cgpSnackbarService: CgpSnackbarService,
    private cgpConfirmationDialogService: CgpConfirmationDialogService,
    private formBuilder: FormBuilder,
    private cgpAlertDialogService: CgpAlertDialogService
  ) { }


  gridFilter: boolean;
  editForm: FormGroup;
  editDataItem: Contact;
  private programId: string;
  system: any;
  private functionId: any;

  ngOnInit() {
    this.systemSelectService.system$
      .subscribe(system => {
        this.system = system;
        if (this.system) {
          this.programId = this.system.ProgramId;
        }
        else {
          this.programId = undefined;
        }
        this.refresh();
      });

    this.systemSelectService.get();

    this.editForm = this.formBuilder.group({
      ProgramId: [""],
      ContactId: ["", Validators.required],
      FunctionId: [""]
    })
  }

  refresh() {
    this.gridFilter = !this.gridFilter;
  }

  onRead = () => {
    var self = this;
    if (this.programId) {
      return this.programFunctionContactService.read("/programId/" + this.programId, true).then(function (dataItem) {
        for (var i = 0; i < dataItem.length; i++) {
          if (dataItem[i].Required) {
            dataItem[i].Description = dataItem[i].Description;
          }
        }
        return dataItem;
      });
    }
    return Promise.resolve([]);
  }

  onEdit(object) {
    this.functionId = object.dataItem.Id;
    this.functionContactService.read("/" + this.functionId + "?$filter=IsActive eq true", true);
  }

  onSave = (dataItem) => {
    var self = this;
    dataItem.FunctionId = this.functionId;

    this.programFunctionContactService.save(dataItem, true).then(function () {
      self.refresh();
      self.cgpSnackbarService.showSnackbar({
        message: "Contact has been assigned",
        duration: 2000
      })
    })
  }

  onDelete = (dataItem) => {
    var self = this;
    if (dataItem.Required) {
      self.cgpAlertDialogService.showAlertDialog({
        title: 'Error',
        message: 'A contact is mandatory for this field. Please edit contact if change is required.',
        alert: 'danger',
        closeLabel: 'Close',
      })
    }
    else if (dataItem.ContactName == "" || dataItem.ContactName == " " || dataItem.ContactName == null) {
      self.cgpAlertDialogService.showAlertDialog({
        title: 'Error',
        message: 'Cannot delete an empty contact field.',
        alert: 'danger',
        closeLabel: 'Close',
      })
    }
    else {
      dataItem.FunctionId = this.functionId;
      this.programFunctionContactService.remove("/" + dataItem.ContactId + "/" + dataItem.ProgramId + "/" + dataItem.Id).then(function () {
        self.refresh();
        self.cgpSnackbarService.showSnackbar({
          message: "Contact has been deleted",
          duration: 2000
        })
      })
    }
  }

  columns: any[] =
    [
      {
        field: "Description",
        title: "Function",
        checkRequired: true
      },
      {
        field: "ContactName",
        title: "Name"
      }
    ]

  template = {
    controls: {
      add: false,
      edit: true,
      delete: true,
      excel: true
    },
    columns: this.columns,
    service: this.programFunctionContactService,
    fileName: "programContacts.xlsx",
    save: this.onSave,
    delete: this.onDelete,
    read: this.onRead
  };

  formDialog = {
    title: "Contact",
    formControls: [
      {
        type: 'combobox',
        name: 'ContactId',
        title: 'Name',
        textField: 'ContactName',
        valueField: 'ContactId',
        placeholder: 'Select Contact...',
        service: this.functionContactService,
        sync: true
      }
    ]
  }
}
